import React from "react";
import { Typography, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import { D } from "../include";
import SignatureCanvas from "react-signature-canvas";



export class SignatureDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      title: this.props.title ? this.props.title : 'Título Default',
      document_id: this.props.document_id ? this.props.document_id : -1 ,
      session_id: this.props.session_id ? this.props.session_id : -1 ,
      procedure_id: this.props.procedure_id ? this.props.procedure_id : -1,
      batch_sign: this.props.batch_sign ? this.props.batch_sign : false
    };
    
  }

  sigPad = {}

  handleSubmit = () => {
    const base64 = this.sigPad.getTrimmedCanvas().toDataURL("image/png");
    const blob = this.b64toBlob(base64.slice("data:image/png;base64,".length), "image/png");
    //console.log(base64);
    
    this.sendFile(blob);

    // Save file locally
    //const dlink = document.createElement("a");
    //dlink.setAttribute("href", base64);
    //dlink.setAttribute("download", "signature.png");
    //dlink.click();

    this.props.dialogClose();
  }
  
  b64toBlob = (b64Data, contentType='', sliceSize=512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    
    const blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }
  
  sendFile = (file) => {
    var chunkSize = 3 * 1024 * 1024;
    const totalChunks = Math.ceil(file.size / chunkSize);
    let chunkNumber = 0;
 
    const uploadChunk = async (chunk, chunkNumber, totalChunks) => {
      const formData = new FormData();
      formData.append('chunk', chunk);
      formData.append('chunkNumber', chunkNumber);
      formData.append('totalChunks', totalChunks);
      formData.append('fileName', 'Signature.png');
      formData.append('type', file.type);
      formData.append('registerIntoDB', true);
  
      this.props.api.post('/FileServer/upload', formData, { 
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((response) => {
        if (response.status === 200) {
          //console.log(`Chunk ${chunkNumber + 1} de ${totalChunks} enviado com sucesso`);
          chunkNumber++;
          if (chunkNumber < totalChunks) {
            const start = chunkNumber * chunkSize;
            const end = Math.min(file.size, start + chunkSize);
            const nextChunk = file.slice(start, end);
            uploadChunk(nextChunk, chunkNumber, totalChunks);
          } else {
            //console.log('Upload completo');
            //console.log("db_record",response.db_record);
            this.props.dialogConfirm(this.state.batch_sign, this.state.document_id, this.state.session_id, response.db_record.id, this.state.procedure_id);
          }
        }
        else {
          //console.log('Erro no upload do chunk:', response.statusText);
        }
      })
      .catch((error) => {
        console.log('Erro:', error.message);     
      })
    };    

 
    const firstChunk = file.slice(0, chunkSize);
    uploadChunk(firstChunk, chunkNumber, totalChunks);     
  };


  handleClear = () => {
      this.sigPad.clear()
  }


  render() {
   return (
     <>
       <DialogTitle>{this.state.title} </DialogTitle>
       <DialogContent>
         <Typography variant="overline">Assinatura não é armazenada</Typography>
         <img alt="Logo da Digicert" src="/static/digicert-cybersecurity.jpg" />
         <D />
         <Button variant="outlined" color="primary" onClick={this.handleClear}>
           Limpar
         </Button>
         <D h="1rem"/>
         <SignatureCanvas 
           ref={(ref) => { this.sigPad = ref }}
           penColor='blue'
           velocityFilterWeight={0.5}
           canvasProps={{
                   height:'202',
                   width: '354',
                   style: {
                     border:'solid',
                     borderWidth:'thin',
                     borderColor:'grey',
                     width:'-webkit-fill-available'
                   },
                   willreadfrequently: 'true'
           }} 
         />
       </DialogContent>
       <DialogActions>
         <Button variant="outlined" color="primary" onClick={this.props.dialogClose}>
           Cancelar
         </Button>
         <Button variant="outlined" color="primary" onClick={this.handleSubmit}>
           Confirmar
         </Button>
       </DialogActions>
     </>
   );
  }
}








